// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2rRpR","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2DueF"};